import DailyBalanceSheetPrintComponent from './daily_balance_sheet_print.component';
import DailyBalanceSheetReportPrintModule from './daily_balance_sheet_report';

let DailyBalanceSheetPrintModule = angular.module('printDailyBalanceSheet', [
	DailyBalanceSheetReportPrintModule
])
	.config(($stateProvider, $urlRouterProvider) => {
		"ngInject";

		$urlRouterProvider.otherwise('/daily-balance-sheet');

		$stateProvider
			.state('printDailyBalanceSheet', {
				url: '/print-daily-balance-sheet',
				component: 'printDailyBalanceSheet',
				data: {
					requireLogin: true,
					requireACL: 'branch_mgmt_daily_balance_sheet.all'	
				},
			});
	})

	.component('printDailyBalanceSheet', DailyBalanceSheetPrintComponent)

	.name;

export default DailyBalanceSheetPrintModule;



// WEBPACK FOOTER //
// ./client/app/components/branch_management/components/daily_balance_sheet/print/index.js